module.exports = __webpack_public_path__ + "media/src/assets/images/info-blue-26c9183369f5042e1a7f6dfff57680fe.svg";